module.exports = __webpack_public_path__ + "img/avatar.e274a23e.png";